import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';
import CenterText from './CenterText';
import schema from './props-schema';

CenterText.schema = schema;
CenterText.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default CenterText;
